// AUTO-GENERATED by scripts/generate-build-info.js at build time.
// DO NOT EDIT and DO NOT COMMIT — this file is git-ignored.
export const BUILD_INFO = {
  version: '0.1.0',
  commit: 'c006aa7',
  branch: 'HEAD',
  buildTime: '2026-10-30T14:05:01.723Z',
} as const
